
export default {
    path: 'payments',
    component: () => import(/* webpackChunkName: "payments" */ './views/Payments.vue'),
    children: [
        {
            path: '/',
            name: 'PaymentsList',
            component: () => import(/* webpackChunkName: "payments" */ './views/PaymentList.vue')
        },
        {
            path: 'view/:id',
            name: 'ViewPayment',
            props: true,
            component: () => import(/* webpackChunkName: "payments" */ './views/PaymentList.vue')
        },
    ],
}
